var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.319 27H21.68C23.898 27 25 25.923 25 23.788v-9.317h-7.747c-1.37 0-2.024-.626-2.024-1.94V5h-4.91C8.113 5 7 6.088 7 8.222v15.566C7 25.933 8.103 27 10.318 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.284 13.065h7.59c-.066-.42-.377-.83-.891-1.334l-5.897-5.756c-.5-.493-.942-.79-1.39-.862v7.398c0 .37.191.554.588.554z",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBlank);
export default __webpack_public_path__ + "static/media/File_Blank.3ca3e5c9738a8c2cdafdd4bf8da1621b.svg";
export { ForwardRef as ReactComponent };